import { IAnalysisValueColumn } from "../../types";
import { TableView } from "../view";

// <reference path="../view.ts" />

export class NitrogenViews extends TableView {

    constructor() {
        super(false, false, false, [new NitrogenView(), new NitrogenAllocView()]);
        this._key = this._template = "groupnitrogen";
        this._name = "Nitrogen analysis";
    }
}

export class NitrogenView extends TableView {

    public static nitrogenAnalysisColumns: IAnalysisValueColumn[] = [
        { name: "Nitrogen", units: "kg/ha", header: "Nitrogen", key: "N" },
    ];

    constructor() {
        super(true, false, false);
        this._key = this._template = "nitrogen";
        this._name = "List";
    }

    get analysisColumns(): IAnalysisValueColumn[] {
        return NitrogenView.nitrogenAnalysisColumns;
    }

}

export class NitrogenAllocView extends TableView {

    public static nitrogenAllocColumns: IAnalysisValueColumn[] = [
        { name: "Nitrogen", units: "kg/ha", header: "Nitrogen", key: "N" },
        { name: "CropN", units: "kg/ha", header: "Crop N", alloc: true, gauge: false },
        { name: "SMN", units: "kg/ha", header: "Organic<br>matter", alloc: true, gauge: false },
        { name: "SNS", units: "kg/ha", header: "SNS", key: "N", alloc: true },
    ];

    constructor() {
        super(true, true, false);
        this._key = this._template = this._template = "nitrogen-alloc";
        this._name = "Allocations";
    }

    get analysisColumns(): IAnalysisValueColumn[] {
        return NitrogenAllocView.nitrogenAllocColumns;
    }

}

